import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { getFrontImage, getLocalizedValue } from '@grandvisionhq/utils';
import { Solution } from '../components/Solution.js';

var SolutionContainer = (_param)=>{
    var { solution  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "solution"
    ]);
    const { getLabel , locale  } = useIntl();
    const solutionProduct = React.useMemo(()=>{
        var ref;
        const imageUrl = `${getFrontImage((ref = solution.media) === null || ref === void 0 ? void 0 : ref.images).url}?w=300&auto=format`;
        return swcHelpers.objectSpread({}, solution, {
            imageUrl
        });
    }, [
        solution
    ]);
    const title = solutionProduct.name ? getLocalizedValue(solutionProduct.name, locale) : getLabel('products.contactLenses.solutions.missing');
    return /*#__PURE__*/ React.createElement(Solution, swcHelpers.extends({}, props, {
        solution: solutionProduct,
        title: title
    }));
};

export { SolutionContainer };
//# sourceMappingURL=SolutionContainer.js.map
